/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Event_Source_Dataset_RowsInputs */



/**
* | output |
* | --- |
* | "New row in a dataset" |
*
* @param {Agent_Event_Source_Dataset_RowsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_event_source_dataset_rows = /** @type {((inputs?: Agent_Event_Source_Dataset_RowsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Event_Source_Dataset_RowsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Zeile in einem Datensatz")
	return /** @type {LocalizedString} */ ("New row in a dataset")
});